export default function style(theme) {
    return {
      backgroundBlur: {
        zIndex: -2,
        position: "fixed",
        height: "100%",
        width: "100%",
        top: 0,
        left: 0,
        overflow: "hidden",
        backgroundColor: "#000",
      },
      blurredCircle1: {
        zIndex: -1,
        borderRadius: "50%",
        backgroundColor: "#5D5FFF",
        opacity: 0.8,
        position: "absolute",
        filter: "blur(190px)",
        top: -10,
        right: -10,
        height: 200,
        width: 200,
        [theme.breakpoints.down("sm")]: {
          height: 200,
          width: 200,
        },
      },
      blurredCircle2: {
        zIndex: -1,
        borderRadius: "50%",
        backgroundColor: "#5D5FFF",
        opacity: 0.8,
        position: "absolute",
        filter: "blur(190px)",
        bottom: -10,
        left: -10,
        height: 200,
        width: 200,
        [theme.breakpoints.down("sm")]: {
          height: 200,
          width: 200,
        },
      },
    };
  }